import { Routes } from "@angular/router";
import { ContactComponent } from "./components/contact/contact.component";

export const routes: Routes = [
  {
    path: "",
    component: ContactComponent,
  },
  { path: "**", redirectTo: "/" },
];
